import { getEnvironmentName, getVerb, getAppName } from './lrsHelpers';
import { lrsEventOnAction } from './lrsTrackEvent';
import selectors from '../../../root/shared/root';
import KeycloakClient from '../../../api/clients/shared/KeycloakClient';

const createLrsMiddleware = (getLrsObjectId, getLrsExtensions) => store => next => action => {
    let nextAction;

    // if this is lrs action and xapi environment is defined
    if (getEnvironmentName()) {
        const state = store.getState();
        const lrsObjectId = getLrsObjectId(action, store);

        if (lrsObjectId) {
            try {
                const verb = getVerb(action);
                const application = getAppName();

                const extensions = getLrsExtensions(action);
                const lrsTrackingInfo = {
                    application,
                    ...selectors.getLrsTrackingInfo(state),
                    ...extensions,
                };
                const staffId = selectors.getUserId(state);
                const sessionId = KeycloakClient.getSessionId();

                nextAction = lrsEventOnAction(
                    verb,
                    lrsObjectId,
                    staffId,
                    lrsTrackingInfo,
                    sessionId,
                ).then(
                    () => next(action),
                    () => next(action),
                );
            } catch (e) {
                // If unable to create LRS event - do not break middleware chain.
                return next(action);
            }
        } else {
            return next(action);
        }
    } else {
        nextAction = next(action);
    }

    return nextAction;
};

export default createLrsMiddleware;
